module.exports = __webpack_public_path__ + "static/media/video-chat-icon.de36a6f8.svg";